import { Base } from './Base.model';

export class WeldLogView extends Base {
  constructor() {
    super();
  }
  public userId: string;
  public additionalColumns: string;
}
